import React, { Component } from "react";
import "../Account.css"
import SignupHeader from "./signup.header";
import SignupFooter from "./signup.footer";
import { Link } from "react-router-dom";
import axios from "axios";



class AdminSignup extends Component {
  state = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    error: '',
    response: '',
    loading: false, // Added loading state
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ error: 'Passwords do not match' });
      return;
    }
    this.setState({ loading: true, error: "", response: "" }); // Set loading to true and clear previous errors/responses
    try {
      const response = await axios.post('https://api.geoinfoacademy.com/api/tutor-register/', {
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        email: this.state.email,
        password: this.state.password,
        password2: this.state.confirmPassword,
      });

      // Handle successful signup (e.g., display a success message)
      console.log('Signup successful:', response.data);
      // Optionally, redirect the user to the login page
      this.setState({ response: response.data })
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        // Parse error response
        let errorMessage = "Signup failed.";
        if (error.response.data.email) {
          errorMessage = error.response.data.email[0];
        } else if (error.response.data.password) {
          errorMessage = error.response.data.password[0]
        } else if (error.response.data.non_field_errors) {
          errorMessage = error.response.data.non_field_errors[0]
        }
        this.setState({ error: errorMessage });
      } else {
        this.setState({ error: "Network error or server unavailable." });
      }
    } finally {
      this.setState({ loading: false }); // Set loading to false after response
    }
  };
  render() {
    return (
      <div className=" account_body sign-up">
        <SignupHeader />
        <h1 className="account_header">Admin Sign Up </h1>
        <p className="account_body"> Become a Toture in Geoinfotech academy </p>
        <div className="account_form_cover">
          <form className="account_form" onSubmit={this.handleSubmit}>
            <label htmlFor="firstName">First Name</label><br />
            <input placeholder="Enter Your First Name " type="text" id="firstName" name="firstName" value={this.state.firstName} onChange={this.handleChange} /><br /><br />
            <label htmlFor="lastName">Last Name</label><br />
            <input placeholder="Enter Your Last Name " type="text" id="lastName" name="lastName" value={this.state.lastName} onChange={this.handleChange} /><br /><br />
            <label htmlFor="email">Email</label><br />
            <input placeholder="Enter Your Email " type="email" id="email" name="email" value={this.state.email} onChange={this.handleChange} /><br /><br />
            <label htmlFor="password">Password</label><br />
            <input placeholder="Enter Your Password" type="password" id="password" name="password" value={this.state.password} onChange={this.handleChange} /><br /><br />
            <label htmlFor="confirmPassword">Comfirm Password</label><br />
            <input placeholder="Enter Your Comfirm Password" type="password" id="confirmPassword" name="confirmPassword" value={this.state.confirmPassword} onChange={this.handleChange} /><br /><br />
            <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? "Signing up..." : "Submit"}
            </button> <br />
            {this.state.response && <p className="account_error green">{this.state.response.message}</p>}
            {this.state.error && <p className="account_error">{this.state.error}</p>}<br />
            <p>Already on Geo-Academy? <Link to="/Admin_login"><span>Login</span></Link></p>
          </form>
        </div>
        <SignupFooter />
      </div>
    )
  }
}

export default AdminSignup